import { render, staticRenderFns } from "./BankDepositForm.vue?vue&type=template&id=d67ceffe"
import script from "./BankDepositForm.vue?vue&type=script&lang=js"
export * from "./BankDepositForm.vue?vue&type=script&lang=js"
import style0 from "./BankDepositForm.vue?vue&type=style&index=0&id=d67ceffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports